import z from "zod";
export const zOrderPhotosTimeTypeSchema = z.enum([
    "BEFORE_CHARGING",
    "IN_CHARGING",
    "AFTER_CHARGING",
]);
